import { ListFilter } from "@components/data-table/filters/listFilter";
import { FilterFormProps } from "@components/data-table/filters/popoverDialog";

export const BatteryPartNumberListFilter = (props: FilterFormProps) => <ListFilter filterField={'batteryPartNumbers'} showNot {...props} />;
export const DeviceModelListFilter = (props: FilterFormProps) => <ListFilter filterField={'models'} showNot {...props} />;
